module.exports = __webpack_public_path__ + "d6760c4294ee83b243a2455d1491a76d.svg";